export const locationsEn = {
  locations: {
    'Others': 'Others'
  }
};
